module.exports = __webpack_public_path__ + "fonts/xeicon.5023a662.eot";